export default __webpack_public_path__ + "static/media/NoOrders.26e18a9b.svg";